import init from "../utils/init"
import { createToast } from "@/javascripts/shared/utils/toast"

init(() => {
  const copyLinkEls = document.querySelectorAll(`.js--copy-link`)

  Array.prototype.forEach.call(copyLinkEls, (el) => {
    el.addEventListener(`click`, (e) => {
      e.preventDefault()

      const input = document.createElement(`input`)
      const url =
        el.getAttribute(`data-link`) ||
        window.location.origin + window.location.pathname

      input.value = url
      document.body.appendChild(input)
      input.select()
      document.execCommand(`copy`)
      document.body.removeChild(input)
      createToast({ message: `Länken har kopierats till urklipp` })
    })
  })
})
